import React from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

import { Start } from 'components/views/Start';
import { faq } from 'content/faq';
import { StrapiService } from 'lib/strapi/StrapiService';
import { MagazineArticleCard } from 'components/sections/Magazine';
import { withSessionSsr } from 'lib/auth';

interface Props {
  articles: MagazineArticleCard[];
}

const Home: NextPage<Props> = ({ articles }) => (
  <>
    <Head>
      <title>Det smarta sättet att köpa bil privat - Blipp</title>
      <meta property="og:title" content="Det smarta sättet att köpa bil privat - Blipp" />
      <meta property="og:url" content="https://blipp.se/" />
      <meta
        property="og:description"
        content="Med blipp:pay är det enklare än någonsin att köpa en bil privat. Låg ränta med ränteavdrag och experthjälp hela vägen."
      />
      <meta
        name="description"
        content="Med blipp:pay är det enklare än någonsin att köpa en bil privat. Låg ränta med ränteavdrag och experthjälp hela vägen."
      />
      <link rel="canonical" href={`https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}`} />
    </Head>

    <Start articles={articles} faq={faq} />
  </>
);

export const getServerSideProps: GetServerSideProps = withSessionSsr(async () => {
  const articles = await StrapiService.getLatestMagazineArticles(3);

  return {
    props: {
      articles,
    },
  };
});

export default Home;
